export const getUsers = () => fetch('https://3867c322-c216-4c40-8db6-7cbbee1a3e04.mock.pstmn.io/admin/users');


export function toQueryString(obj, prefix) {
  var str = [], k, v;
  for(var p in obj) {
      if (!obj.hasOwnProperty(p)) {continue;} // skip things from the prototype
      if (~p.indexOf('[')) {
          k = prefix ? prefix + "[" + p.substring(0, p.indexOf('[')) + "]" + p.substring(p.indexOf('[')) : p;
// only put whatever is before the bracket into new brackets; append the rest
      } else {
          k = prefix ? prefix + "[" + p + "]" : p;
      }
      v = obj[p];
      str.push(typeof v == "object" ?
        toQueryString(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
  }
  return str.join("&");
}